import Cookies from "universal-cookie";

import { HRBackEndUrl } from "../config";

export const loginHRSite = logged => {
  let domain = process.env.REACT_APP_FRONTEND_URL.includes("localhost")
    ? null
    : process.env.REACT_APP_INVEX_DOMAIN;

  console.log(domain);
  // console.log("logged", logged);
  const {
    user: { email, password },
    backendApi,
  } = logged;
  fetch(HRBackEndUrl + "/users/signIn", {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ username: email, password: password, backendApi }),
  })
    .then(response => {
      if (response) {
        response.json().then(responseJson => {
          // console.log("responseJson", responseJson);
          if (responseJson.success && responseJson.user) {
            const expiryDate = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
            const cookies = new Cookies();
            cookies.set("isLoggedIn", true, {
              // path: "/",
              expires: expiryDate,
              ...(domain ? { domain } : {}),
            });
            cookies.set("userId", responseJson.user._id, {
              // path: "/",
              expires: expiryDate,
              ...(domain ? { domain } : {}),
            });
            cookies.set("userId", responseJson.user._id, {
              // path: "/",
              expires: expiryDate,
              ...(domain ? { domain } : {}),
            });
            cookies.set("token", responseJson.user.token, {
              // path: "/",
              expires: expiryDate,
              ...(domain ? { domain } : {}),
            });
            cookies.set("isFirstTime", responseJson.user.isFirstTime, {
              // path: "/",
              expires: expiryDate,
              ...(domain ? { domain } : {}),
            });
            cookies.set("branch_id", responseJson.branch, {
              // path: "/",
              expires: expiryDate,
              ...(domain ? { domain } : {}),
            });
            cookies.set("branch_url", backendApi?.url, {
              // path: "/",
              expires: expiryDate,
              ...(domain ? { domain } : {}),
            });
            cookies.set("branch_name", backendApi?.name, {
              // path: "/",
              expires: expiryDate,
              ...(domain ? { domain } : {}),
            });
            cookies.set(
              "company_id",
              responseJson.user.company_id
                ? responseJson.user.company_id
                : process.env?.REACT_APP_HR_COMPANY,
              {
                // path: "/",
                expires: expiryDate,
                ...(domain ? { domain } : {}),
              }
            );

            if (responseJson.user.isAdmin || responseJson.user.isSuperAdmin) {
              if (responseJson.user.isSuperAdmin) {
                cookies.set("isSuperAdmin", true, {
                  // path: "/",
                  expires: expiryDate,
                  ...(domain ? { domain } : {}),
                });
              } else if (responseJson.user.isAdmin) {
                cookies.set("isAdmin", true, {
                  // path: "/",
                  expires: expiryDate,
                  ...(domain ? { domain } : {}),
                });
              }
            }
          }
        });
      }
    })
    .catch(error => {
      console.log(error);
    });
};

export const loginHRSiteWaitable = logged => {
  return new Promise((resolve, reject) => {
    const domain = process.env.REACT_APP_FRONTEND_URL.includes("localhost")
      ? null
      : process.env.REACT_APP_INVEX_DOMAIN;

    const {
      user: { email, password },
      backendApi,
    } = logged;

    fetch(`${HRBackEndUrl}/users/signIn`, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: email,
        password,
        backendApi,
      }),
    })
      .then(response => {
        if (!response) {
          resolve({ success: false, message: "No response received" });
          return;
        }

        return response.json().then(responseJson => {
          if (responseJson.success && responseJson.user) {
            const expiryDate = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
            const cookies = new Cookies();
            const cookieOptions = {
              expires: expiryDate,
              ...(domain ? { domain } : {}),
            };

            // Set all cookies with the same options
            const cookieData = {
              isLoggedIn: true,
              userId: responseJson.user._id,
              token: responseJson.user.token,
              isFirstTime: responseJson.user.isFirstTime,
              branch_id: responseJson.branch,
              branch_url: backendApi?.url,
              branch_name: backendApi?.name,
              company_id: responseJson.user.company_id || process.env?.REACT_APP_HR_COMPANY,
            };

            // Set user role cookies if applicable
            if (responseJson.user.isSuperAdmin) {
              cookieData.isSuperAdmin = true;
            } else if (responseJson.user.isAdmin) {
              cookieData.isAdmin = true;
            }

            // Set all cookies at once
            Object.entries(cookieData).forEach(([key, value]) => {
              cookies.set(key, value, cookieOptions);
            });

            // Resolve with success data including user info
            resolve({
              success: true,
              user: responseJson.user,
              branch: responseJson.branch,
            });
          } else {
            // Resolve with failure and any error message
            resolve({
              success: false,
              message: responseJson.message || "Login failed",
            });
          }
        });
      })
      .catch(error => {
        console.error("Login error:", error);
        reject(error);
      });
  });
};
